import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';


@Component({
    templateUrl: './installed.page.html',
})

export class CompaniesInstalledPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    @ViewChild("frmReset") frmReset: DxValidationGroupComponent;
    @ViewChild("frmReset1") frmReset1: DxValidationGroupComponent;
    @ViewChild("frmReset2") frmReset2: DxValidationGroupComponent;

    items: any[] = [
        {
            title: "Backup & Restore",
            name: "backup",
            icon: "fa fa-database",
            showOnRow: true
        },
        {
            title: "Resend Account Email",
            name: "resend",
            icon: "fa fa-send",
            showOnRow: true
        },
        {
            title: "Export",
            name: "export",
            icon: "fa fa-file-excel-o ",
        },
        {
            title: "Set Distributor",
            name: "setDistributor",
            icon: "fa fa-share-alt",
            showOnRow: true
        },
        {
            title: "Set Number of Users",
            name: "setUserCount",
            icon: "fa fa-users",
            showOnRow: true
        }
    ]


    loadingVisible: boolean = false;
    //
    backupSelectedKeys: any[] = [];
    popupBackupVisible: boolean = false;
    popupLicenseVisible: boolean = false;
    popupInstallVisible: boolean = false;

    backupList: any[] = [];
    licenseList: any[] = [];
    //
    popupDistVisible: boolean = false;
    selDistributor: any = {};
    distributors: any[];
    //
    popupUserInfoVisible: boolean = false;
    selUserInfo: any = {};
    //
    popupContactInfoVisible: boolean = false;
    selContactInfo: any = {};

    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "backup":
                {

                    this.updateBackupList();
                    break;
                }
            case "license":
                {

                    this.updateLicenseList();
                    break;
                }
            case "resend":
                {
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        let data = this.grid.instance.getSelectedRowsData()[0];
                        this.api.post("/Company/SendPassEmail", { ID: data.ID }).then(() => {
                            this.uiService.success();
                        });
                    }
                    break;
                }
            case "export":
                {
                    this.grid.instance.exportToExcel(false);
                    break;
                }
            case "setDistributor":
                {
                    let data = this.grid.instance.getSelectedRowsData()[0];
                    this.selDistributor = { DistributorId: data.DistributorId, Id: data.ID };
                    this.api.get("/Distributor/List").then(c => {
                        this.distributors = c;
                    }).catch(() => {
                    }).then(() => {
                        this.popupDistVisible = true;
                    });
                    break;
                }
            case "setUserCount":
                {
                    let data = this.grid.instance.getSelectedRowsData()[0];
                    this.selUserInfo = {
                        Id: data.ID, MobileUser: data.MobileUser, AdminUser: data.AdminUser
                        , SubContractor: data.SubContractor, Apprentice: data.Apprentice
                    };
                    this.popupUserInfoVisible = true;
                    break;
                }
        }
    }

    showContact(data)
    {
        this.selContactInfo = {
            Id: data.ID, ContactFirstName: data.ContactFirstName, ContactLastName: data.ContactLastName, 
            Phone: data.Phone, Email: data.Email, StreetAddress: data.StreetAddress , Suburb:data.Suburb,
            State:data.State , Country:data.Country,ZipCode:data.ZipCode
        };
        this.popupContactInfoVisible=true
    }

    formatContact(firstName,LastName,Company)
    {
        if(firstName==null && LastName==null)
            return Company;
        else 
            return firstName+' '+LastName;
    }

    format(data) {
        return 'Used Space: ' + data.StorageUsed + " MB";
    }

    takeBackup() {
        let list = this.grid.instance.getSelectedRowKeys();
        if (list.length) {
            let id = list[0];
            this.loadingVisible = true;
            this.api.post("/Company/Backup/New", { id: id }).then(c => {
                this.uiService.success();
                this.updateBackupList();
            }).catch(() => {
            }).then(() => {
                this.loadingVisible = false;
            });
        }
    }

    restoreBackup(id) {
        this.loadingVisible = true;
        this.api.post("/Company/Backup/Restore", { id: id }).then(c => {
            this.uiService.success();
            this.updateBackupList();
        }).catch(() => {
        }).then(() => {
            this.loadingVisible = false;
        });
    }

    deleteBackup(id) {
        this.uiService.delete().then(c => {
            this.loadingVisible = true;
            this.api.post("/Company/Backup/Delete", { id: id }).then(c => {
                this.uiService.success();
                this.updateBackupList();
            }).catch(() => {
            }).then(() => {
                this.loadingVisible = false;
            });
        });

    }

    updateBackupList() {
        let list = this.grid.instance.getSelectedRowKeys();
        if (list.length) {
            let id = list[0];
            this.backupList = [];
            this.loadingVisible = true;
            this.api.get("/Company/Backup/List", { id: id }).then(c => {
                this.popupBackupVisible = true;
                this.backupList = c as any[];
            }).catch(() => {
            }).then(() => {
                this.loadingVisible = false;
            });
        }

    }

    updateLicenseList() {
        let list = this.grid.instance.getSelectedRowKeys();
        if (list.length) {
            let id = list[0];
            this.licenseList = [];
            this.loadingVisible = true;
            this.api.get("/Company/License/List", { id: id }).then(c => {
                this.popupLicenseVisible = true;
                this.licenseList = c as any[];
            }).catch(() => {
            }).then(() => {
                this.loadingVisible = false;
            });
        }

    }

    saveDistributor(companyId) {
       // if (this.frmReset.instance.validate().isValid) {
            this.loadingVisible = true;
            this.api.post("/Company/SetDistributor", { ID: companyId, DistributorId: this.selDistributor.DistributorId }).then(c => {
                this.grid.instance.refresh();
                this.loadingVisible = false;
            }).catch(() => {
            }).then(() => {
                this.popupDistVisible = false;
            });
       // }
    }

    cancelDistributor(e) {
        this.popupDistVisible = false;
    }


    saveUserInfo(companyId) {
        if (this.frmReset1.instance.validate().isValid) {
            this.loadingVisible = true;
            this.api.post("/Company/SetUserInfo", {
                ID: companyId, MobileUser: this.selUserInfo.MobileUser, AdminUser: this.selUserInfo.AdminUser
                , SubContractor: this.selUserInfo.SubContractor, Apprentice: this.selUserInfo.Apprentice
            }).then(c => {
                this.grid.instance.refresh();
                this.loadingVisible = false;
            }).catch(() => {
            }).then(() => {
                this.popupUserInfoVisible = false;
            });
        }
    }

    cancelUserInfo(e) {
        this.popupUserInfoVisible = false;
    }

    saveContactInfo(companyId) {
        if (this.frmReset2.instance.validate().isValid) {
            this.loadingVisible = true;  
            this.api.post("/Company/SetContactInfo", {
                ID: companyId, ContactFirstName: this.selContactInfo.ContactFirstName, ContactLastName: this.selContactInfo.ContactLastName
                , Phone: this.selContactInfo.Phone, Email: this.selContactInfo.Email, StreetAddress: this.selContactInfo.StreetAddress
                , Suburb: this.selContactInfo.Suburb, State: this.selContactInfo.State, Country: this.selContactInfo.Country
                , ZipCode: this.selContactInfo.ZipCode
            }).then(c => {
                this.grid.instance.refresh();
                this.loadingVisible = false;
            }).catch(() => {
            }).then(() => {
                this.popupContactInfoVisible = false;
            });
        }
    }

    cancelContactInfo(e) {
        this.popupContactInfoVisible = false;
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Companies/installed.page.ts